import styled from 'styled-components';

export const DeviceFrame = styled.div`
  width: 100%;
  max-width: 375px;
  aspect-ratio: 375 / 740;
  background: #000;
  border-radius: clamp(22px, 4vw, 42px);
  padding: clamp(6px, 0.4vw, 6px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  position: relative;
  margin: 0 auto;

  &::before {
    content: '';
    position: absolute;
    left: -0.8%;
    top: 16.2%;
    width: 0.8%;
    height: 4.3%;
    background: #000;
    border-radius: 2px 0 0 2px;
  }

  &::after {
    content: '';
    position: absolute;
    left: -0.8%;
    top: 24.3%;
    width: 0.8%;
    height: 8.4%;
    background: #000;
    border-radius: 2px 0 0 2px;
  }
`;

export const SideButtonsRight = styled.div`
  position: absolute;
  right: -0.8%;
  top: 32.4%;
  width: 0.8%;
  height: 10.5%;
  background: #000;
  border-radius: 0 2px 2px 0;
`;

export const SideButtonsLeft = styled.div`
  position: absolute;
  left: -0.8%;
  top: 35.1%;
  width: 0.8%;
  height: 8.4%;
  background: #000;
  border-radius: 0 2px 2px 0;
`;

export const Screen = styled.div`
  width: 100%;
  height: 100%;
  background: #ffffff;
  border-radius: 36px;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const StatusBar = styled.div`
  height: 47px;
  background: #f8f8f8;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  color: #000;
  font-size: 15px;
  font-weight: 500;
  position: relative;
  z-index: 1;
`;

export const StatusBarIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const CellularBars = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 2px;
  height: 14px;
`;

export const Bar = styled.div<{ height: string }>`
  width: 3px;
  height: ${props => props.height};
  background: #000;
  border-radius: 1px;
`;

export const BatteryIcon = styled.div`
  width: 24px;
  height: 11px;
  border-radius: 3px;
  position: relative;
  background: #cccccc;
  display: flex;
  align-items: center;
  margin-top: 4px;

  &::after {
    content: '';
    position: absolute;
    right: -2.3px;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: 4px;
    background: #cccccc;
    border-radius: 0 4px 4px 0;
  }
`;

export const BatteryFill = styled.div`
  width: 85%;
  height: 100%;
  background: #000000;
  border-radius: 3px 0 0 3px;
  position: relative;
`;

export const DynamicIsland = styled.div`
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  width: 126px;
  height: 32px;
  background: #000;
  border-radius: 19px;
  z-index: 2;
`;

export const NavigationBar = styled.div`
  background: #f8f8f8;
  border-bottom: 1px solid #e5e5e5;
  padding: 4px 16px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 44px;
`;

export const BackButton = styled.div`
  color: #007aff;
  font-size: 45px;
  font-weight: 400;
  line-height: 1;
`;

export const WhatsAppBackButton = styled.div`
  color: #000;
  font-size: 45px;
  font-weight: 400;
  line-height: 1;
`;

export const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  padding-top: 3px;
  margin-left: -12px;
`;

export const ContactAvatar = styled.div`
  width: 45px;
  height: 45px;
  border-radius: 60px;
  background: #939393;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
`;

export const ContactNameHeader = styled.div`
  color: #000;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
`;

export const WhatsAppContactInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  justify-content: flex-start;
  margin-left: 1.5rem;
  padding-top: 3px;
`;

export const WhatsAppContactAvatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 16px;
  background: #25d366;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
  font-weight: 600;
`;

export const WhatsAppContactName = styled.div`
  color: #000;
  font-size: 15px;
  font-weight: 500;
`;

export const MessagesContainer = styled.div`
  flex: 1;
  background: #ffffff;
  padding: 16px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

export const WhatsAppMessagesContainer = styled.div`
  flex: 1;
  background: #ece5dd;
  padding: 16px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

export const TimestampCenter = styled.div`
  text-align: center;
  color: #8e8e93;
  font-size: 11px;
  margin: 4px 0 6px 0;
`;

export const TodayBadge = styled.div`
  text-align: center;
  margin: 4px 0 6px 0;
`;

export const TodayLabel = styled.span`
  background: #ffffff;
  color: #666;
  font-size: 11px;
  padding: 4px 12px;
  border-radius: 12px;
  margin-bottom: 8px;
`;

export const MessageBubble = styled.div<{ isFromUser: boolean }>`
  max-width: 75%;
  margin: 2px 0;
  align-self: ${props => (props.isFromUser ? 'flex-end' : 'flex-start')};
  display: flex;
  flex-direction: column;
`;

export const BubbleContent = styled.div<{ isFromUser: boolean }>`
  background: ${props => (props.isFromUser ? '#007aff' : '#e9e9eb')};
  color: ${props => (props.isFromUser ? '#ffffff' : '#000000')};
  padding: 12px 16px;
  border-radius: 18px;
  border-bottom-right-radius: ${props => (props.isFromUser ? '4px' : '18px')};
  border-bottom-left-radius: ${props => (props.isFromUser ? '18px' : '4px')};
  font-size: 15px;
  line-height: 1.3;
  word-wrap: break-word;
  max-width: 100%;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    ${props => (props.isFromUser ? 'right: -15px;' : 'left: -15px;')}
    width: 0;
    height: 0;
    border: 12px solid transparent;
    ${props =>
      props.isFromUser
        ? 'border-left-color: #007aff; border-bottom: 0;'
        : 'border-right-color: #e9e9eb; border-bottom: 0;'}
  }
`;

export const WhatsAppBubbleContent = styled.div<{ isFromUser: boolean }>`
  background: ${props => (props.isFromUser ? '#dcf8c6' : '#ffffff')};
  color: #000;
  padding: 8px 12px 18px 12px;
  border-radius: 8px;
  border-bottom-right-radius: ${props => (props.isFromUser ? '4px' : '8px')};
  border-bottom-left-radius: ${props => (props.isFromUser ? '8px' : '4px')};
  font-size: 15px;
  line-height: 1.3;
  word-wrap: break-word;
  max-width: 100%;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    ${props => (props.isFromUser ? 'right: -15px;' : 'left: -15px;')}
    width: 0;
    height: 0;
    border: 10px solid transparent;
    ${props =>
      props.isFromUser
        ? 'border-left-color: #dcf8c6; border-bottom: 0;'
        : 'border-right-color: #ffffff; border-bottom: 0;'}
  }
`;

export const MessageTime = styled.div<{ isFromUser: boolean }>`
  position: absolute;
  bottom: 4px;
  right: 8px;
  color: #666;
  font-size: 11px;
`;

export const InputArea = styled.div`
  background: #f8f8f8;
  border-top: 1px solid #e5e5e5;
  padding: 8px 16px;
  display: flex;
  align-items: flex-end;
  gap: 12px;
  min-height: 60px;
  padding-bottom: 1.6rem;
`;

export const PlusButton = styled.div`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #616161;
  font-size: 24px;
  font-weight: 300;
  line-height: 1;
  background: #e9e9eb;
  border-radius: 100px;
`;

export const MessageInputWrapper = styled.div`
  flex: 1;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 20px;
  min-height: 36px;
  display: flex;
  align-items: center;
`;

export const MessageInput = styled.div`
  flex: 1;
  padding: 8px 16px;
  color: #8e8e93;
  font-size: 14px;
  line-height: 20px;
`;

export const BottomIsland = styled.div`
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  width: 126px;
  height: 4px;
  background: #000;
  border-radius: 19px;
  z-index: 2;
`;
